import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    {
        count: 1,
        title: `HUNT BEST CRANES`,
        icon: require('./../../images/icon/crane-1.png'),
        description: 'Seek out the cranes that embody the highest degree of optimization.',
    },
    {
        count: 2,
        title: 'CUSTOMER RELATIONSHIP',
        icon: require('./../../images/icon/renovation.png'),
        description: 'At the core of effective customer engagement lies the commitment to delivering tailored experiences that resonate with the unique needs, preferences, and aspirations of individual customers.',
    },
    {
        count: 3,
        title: 'TECHNOCRAT',
        icon: require('./../../images/icon/toolbox.png'),
        description: 'Empowering the Future Through Expertise.',
    },
    {
        count: 4,
        title: 'EXCELLENCE',
        icon: require('./../../images/icon/compass.png'),
        description: 'Provides standard of excellence ,precision, durability, efficiency, safety, and adherence to specifications.',
    }
]

var img1 = require('./../../images/background/ptn-1.png');

class Specialization4 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-tb80 bg-white bg-repeat square_shape2 inner-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Specialization</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                                    {services.map((item, index) => (
                                        <div className="col-md-3 col-sm-6" key={index}>
                                            <div className="mt-icon-box-wraper m-b30">
                                                <div className="relative icon-count-2 bg-gray p-a30 p-tb50 min-height-46 min-height-530 min-height-475 ">
                                                    <span className="icon-count-number">{item.count}</span>
                                                    <div className="icon-md inline-icon m-b15 text-primary scale-in-center">
                                                        <span className="icon-cell"><img src={item.icon} alt=""/></span>
                                                    </div>
                                                    <div className="icon-content">
                                                        <h4 className="mt-tilte m-b25">{item.title}</h4>
                                                        <p>{item.description}</p>
                                                        <NavLink to={"#"} className="site-button-link" data-hover="Read More" onClick={(e) => e.preventDefault()}>Read More <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Specialization4;
